export default __webpack_public_path__ + "static/media/steps.fd071129.svg";